/* eslint-disable react/jsx-no-target-blank */
import React, { useCallback, useEffect, useState } from 'react';

import Link from 'next/link';
import Cookies from 'js-cookie';

import * as S from './styles';

interface IBanner {
  banner: any;
  index: number;
}

export default function BannerItem({ banner, index }: IBanner) {
  const [windowWidth, setWindowWidth] = useState('web');

  function resizeWindow() {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 768) {
        setWindowWidth('web');
      } else {
        setWindowWidth('mobile');
      }
    }
  }

  useEffect(() => {
    resizeWindow();
  }, []);

  if (typeof window !== 'undefined') {
    window.addEventListener('resize', resizeWindow);
  }

  const handleBanner = useCallback(async (banner, index) => {
    let creative_slot;

    if (banner.tipo == 'BOX') creative_slot = `banner_box${index + 1}`;
    else if (banner.tipo == 'TARJA') creative_slot = `banner_tarja${index + 1}`;
    else if (banner.tipo == 'TOPO') creative_slot = `banner_topo${index + 1}`;
    else if (banner.tipo == 'VITRINE')
      creative_slot = `banner_vitrine${index + 1}`;
    else creative_slot = `banner_full${index + 1}`;

    const campanha = {
      promotionId: banner.campanha,
      promotionName: banner.campanha,
      creative_name: banner.imagemUrl,
      creative_slot,
      itemListName: banner.titulo,
    };

    Cookies.set('@SportNutrition:campanha', JSON.stringify(campanha));
  }, []);

  return (
    <S.Container
      className="banner-item"
      key={`${banner.id}-${banner.titulo}`}
      onClick={() => handleBanner(banner, index)}
      style={{ backgroundColor: banner.backgroundColor }}
    >
      <Link
        href={
          banner.redirecionarUrl !== null
            ? `${banner.redirecionarUrl}?campanha=true`
            : '/'
        }
        passHref
      >
        {banner.abrirNovaJanela ? (
          <a
            href={`${banner.redirecionarUrl}`}
            title={banner.titulo}
            target={banner.abrirNovaJanela ? '_blank' : ''}
            rel={banner.abrirNovaJanela ? 'noopener noreferrer' : ''}
          >
            <img
              loading="lazy"
              src={
                windowWidth === 'web'
                  ? banner.imagemUrl
                  : banner.imagemMobileUrl
              }
              alt={banner.titulo}
            />
          </a>
        ) : (
          <a href={`${banner.redirecionarUrl}` || '/'}>
            <img
              loading="lazy"
              title={banner.titulo}
              src={
                windowWidth === 'web'
                  ? banner.imagemUrl
                  : banner.imagemMobileUrl
              }
              alt={banner.titulo}
            />
          </a>
        )}
      </Link>
    </S.Container>
  );
}
